import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/Home.vue';
import Profile from '@/views/Profile.vue';
import ProjectsEdit from '@/views/ProjectsEdit.vue';
import ProfileEdit from '@/views/ProfileEdit.vue';
// import CourseOverview from '@/views/kursoversikt/Kursoversikt.vue';
// import Task from '@/views/kursoversikt/Oppgave.vue';
import FirstTimeRegistration from '@/views/FirstTimeRegistration.vue';
import ObligList from '@/views/ObligList.vue';
import Oblig from '@/views/Oblig.vue';
import CandidateSearch from '@/views/CandidateSearch';
// import FAQ from '@/views/FAQ';
import Error404 from '@/views/Error404';
import VerifiserEpost from '@/views/VerifiserEpost.vue';
import AdminPanel from '@/views/AdminPanel.vue';
import AllStudents from '@/views/students/AllStudents.vue';
import GetStudents from '@/views/students/GetStudents.vue';
import SubmissionsStudents from '@/views/students/SubmissionsStudents.vue';
import EntranceExam from '@/views/EntranceExam.vue';


import { baseGuard } from "@/auth/baseGuard";
import { adminGuard } from "@/auth/adminGuard";
import { profileGuard } from '../auth/profileGuard';
import { emailGuard } from '../auth/emailGuard';

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    component: Home,
    beforeEnter: baseGuard,
    meta: { hideNavigation: true }
},
{
    path: '/personvern',
    name: 'PrivacyPolicy',
    /*
     * Route level code-splitting.
     * This generates a separate chunk (about.[hash].js) for this route
     * which is lazy-loaded when the route is visited.
     */
    component: () => import('@/views/PrivacyPolicy')
},
{
    path: '/verifiser-epost',
    name: 'VerifiserEpost',
    component: VerifiserEpost,
    beforeEnter: emailGuard,
},
{
    path: '/profil',
    name: 'Profile',
    component: Profile,
    beforeEnter: profileGuard, // "profileGuard" kaller igjen "baseGuard".
},
{
    path: '/profil/registrer',
    name: 'Registration',
    component: FirstTimeRegistration,
    beforeEnter: baseGuard,
},
{
    path: '/profil/:id',
    name: 'ProfileWithId',
    component: Profile,
    beforeEnter: profileGuard,
},
{
    path: '/profil/rediger',
    name: 'ProfileEdit',
    component: ProfileEdit,
    beforeEnter: baseGuard,
},
{
    path: '/prosjekter/rediger/:id',
    name: 'ProjectsEditWithId',
    component: ProjectsEdit,
    beforeEnter: profileGuard,
},
{
    path: '/prosjekter/rediger/',
    name: 'ProjectsEdit',
    component: ProjectsEdit,
    beforeEnter: profileGuard,
},
{
    path: '/obligatoriske-oppgaver',
    name: 'ObligList',
    component: ObligList,
    beforeEnter: profileGuard, 
},
{
    path: '/obligatoriske-oppgaver/:id',
    name: 'Oblig',
    component: Oblig,
    beforeEnter: profileGuard, 
},
{
    path: encodeURI('/søk'),
    name: 'CandidateSearch',
    component: CandidateSearch,
    beforeEnter: profileGuard
},
{
    path: '/adminpanel',
    name: 'AdminPanel',
    component: AdminPanel,
    beforeEnter: adminGuard
},
{
    path: '/adminpanel/student-liste',
    name: 'AllStudents',
    component: AllStudents,
    // beforeEnter: adminGuard,
},
{
    path: '/adminpanel/get-liste',
    name: 'GetStudents',
    component: GetStudents,
    // beforeEnter: adminGuard,
},
{
    path: '/adminpanel/søkere-liste',
    name: 'SubmissionsStudents',
    component: SubmissionsStudents,
    // beforeEnter: adminGuard,
},
{
    path: '/entrance-exam',
    name: 'EntranceExam',
    component: EntranceExam,
    // beforeEnter: adminGuard,
},

{
    /*
     * Denne må være nederst!
     */
    path: '/*',
    name: 'Error404',
    component: Error404,
},
]

const router = new VueRouter({
    scrollBehavior() {
        return { x: 0, y: 0 };
      },
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router